/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/**
 * Optimizely Forms Extension Component
 * @module patterns/components/form-and-content/forms/forms
 */

import { type App } from '~/app';
import { refreshSelectData, resetSelectField} from '~/patterns/components/form-and-content/fields/select/select';

import { selectDefaultInButtonGroup } from '../fields/button-grouping/button-grouping';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let $$epiforms: any;

const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];
export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Form Component');

    app.afterMount
        .then(() =>  setTimeout(() => {
            mountOptimizelyFormExtensions(listeners);
        }, 300))
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Form Component', error);
        });

    // eslint-disable-next-line @typescript-eslint/naming-convention
    return function destroyEPiForm() {
        unMountOptimizelyFormExtensions(listeners);

        app.logger.debug('[DXA] Form Component destroyed');
    };
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export function mountOptimizelyFormExtensions(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
    root: HTMLElement | null = null
) {
    let rootNode: Document | HTMLElement = document;
    if (root) rootNode = root;

    const forms = rootNode.querySelectorAll<HTMLElement>('form.EPiServerForms');

    if (forms.length > 0) {
        // initialise EPiServerForms.js file if a form is found
        initialiseEpiServerForms();
        
        let remindMeFormCount = 0;

        for (const [index, form] of forms.entries()) {
            // Only display the first instance of the remind me form on the page
            // TODO: Remove this logic and only render 1 form in the backend.
            // We will leave as is for now as not to change components too much before release
            if (form.dataset.formType == 'RemindMe' ) {
                remindMeFormCount++;
                if(remindMeFormCount>1){
                    form.remove();
                }
            }
            
            initialiseFormRecaptcha(form,"in-page");
            // Form grid DOM updates - looks for start and end DIV elements and wraps inner content
            // Removes the use of the form grid container component
            // It causes issues accessing inner form elements for validation, submission and dependency
            const startDivs = form.querySelectorAll<HTMLElement>('.form-start-container');
            for (const startDiv of startDivs) {
                const columns = startDiv.dataset.colsToSplit ? Number(startDiv.dataset.colsToSplit) : 1;
                const gridContainer = document.createElement('div');
                gridContainer.classList.add('grid', 'grid-cols-1', `md:grid-cols-${columns}`, 'gap-x-8');
                const containerChildren = [];
                let endDiv;

                let element = startDiv;
                // For each start div, look for the next end div unless there is no next sibling element or there is another start element
                while (
                    element &&
					!element.classList.contains('form-end-container') &&
					!element.nextElementSibling?.classList.contains('form-start-container')
                ) {
                    element = element.nextElementSibling as HTMLElement;

                    if (element) {
                        if (element.classList.contains('form-end-container')) {
                            endDiv = element;
                        } else {
                            containerChildren.push(element);
                        }
                    }
                }

                if (endDiv) {
                    for (const containerChild of containerChildren) {
                        gridContainer.append(containerChild);
                    }

                    endDiv.before(gridContainer);
                }
            }

            //check if any field is dependent on other
            const dependentElement = form.querySelectorAll<HTMLElement>('[data-dependent-on]');
            if (dependentElement && dependentElement.length > 0) {
                for (const currentElement of dependentElement) {
                    //Grab the id of the controlling elements
                    const currentControllingElementIdsRaw = currentElement.dataset.dependentOn;
                    const currentControllingElementIds=currentControllingElementIdsRaw?currentControllingElementIdsRaw.includes(",")? currentControllingElementIdsRaw.split(","): [currentControllingElementIdsRaw]:[''];
                    //grab the api endpoint for override
                    const currentApiToOverrideData = currentElement.dataset.override;
                    if (currentElement && currentControllingElementIds && currentApiToOverrideData) {
                        //On each click load the data on dependent element
                        bindTheClickListenerToControllingElement(
                            form,
                            currentControllingElementIds,
                            currentElement,
                            currentApiToOverrideData
                        );
                        //Refresh the element if there is a default selection on controlling element
                        refreshTheDependentData(
                            currentElement,
                            getDefaultUrl(form, currentControllingElementIds, currentApiToOverrideData)
                        );
                    }
                }
            }

           
            const identityElements = form.querySelectorAll<HTMLInputElement>('[data-hidden-identity-id]');
            if (identityElements && identityElements.length > 0) {
                const userIdentityId = localStorage
                    ? localStorage.getItem('website-user-identity')
                    : getCookie('website-user-identity');

                for (const element of identityElements) {
                    element.value = userIdentityId ?? '';
                }
            }
			
            if ($$epiforms !== undefined) {
                $$epiforms(document).ready(function myfunction() {
                    // listen to event when form is about submitting
                    $$epiforms(".EPiServerForms").on("formsStartSubmitting", function (event: any) {
                        //var $formContainer = $('#' + data.workingFormInfo.Id);
                        //$formContainer.addClass("loading");
                        $$epiforms(".EPiServerForms [data-f-type='submitbutton'] .loading").removeClass("hide");
                        if(event.workingFormInfo.Name === "Stockland Hub Callback Request Form" && !event.isFinalizedSubmission)
                        {
                            $$epiforms(".EPiServerForms [data-f-type='submitbutton'] .loading").addClass("hide");
                        }
                    });
                    $$epiforms(".EPiServerForms").on("formsSubmitted", function (event: any) {
                        form.querySelector<HTMLHeadingElement>('.Form__Title')?.classList.add('hidden');

                        if (event.workingFormInfo.Name === "LLC Home Visualiser Enquiry Form")
                        {
                            const enquiryId = form.querySelector<HTMLInputElement>("input[data-enquiry-id]")!.value;

                            let intervalId: ReturnType<typeof setInterval>;

                            const url = `/pdf/home-visualiser/hv_${enquiryId}.pdf`;

                            const checkPdf = () => {
                                fetch(url, { method: "HEAD" })
                                    .then(response => {
                                        if (response.status === 200) {
                                            const hvSave = document.createElement('a');
                                            hvSave.href = url;
                                            hvSave.download = `hv_${enquiryId}.pdf`;
                                            document.body.append(hvSave);
                                            hvSave.click();
                                            hvSave.remove();

                                            // Update form success message
                                            let successMessage = '<div class="text-center">';
                                            successMessage += '<div class="pt-12">Thank you for your enquiry. If your saved design has not automatically started downloading click the button below.</div>';
                                            successMessage += `<div class="pt-6 md:pt-15 pb-16"><a href="${url}" class="btn" data-theme="btn--style-1" target="_blank">Download PDF</a></div>`;
                                            successMessage += '</div>';
                                            const formResponse = form.querySelector<HTMLElement>('.EPiServerForms .Form__Status__Message');
                                            if (formResponse) {
                                                formResponse.innerHTML = successMessage;
                                            }
                                            
                                            clearInterval(intervalId); // stop checking once the PDF is ready
                                        } else {
                                            console.log('PDF not ready yet. Server responded with status:', response.status);
                                        }
                                    })
                                    .catch(error => console.error('An error occurred while trying to fetch the PDF:', error));
                            };

                            intervalId = setInterval(checkPdf, 1000); // check every second
                        }
                        else if (event.workingFormInfo.Name === "Stockland Hub Callback Request Form" && event.isFinalizedSubmission)
                            {
                                var linkBlock= document.querySelector(".hub-suggestion-block");
                                linkBlock?.classList.remove("hidden");
                                event.isFinalizedSubmission=false;
                            }
                    });
			
                    // formsSubmittedError
                    $$epiforms(".EPiServerForms").on("formsSubmittedError", function () {
                        $$epiforms(".EPiServerForms [data-f-type='submitbutton'] .loading").addClass("hide");
                    });
                    
                    const ackSection = form.querySelector<HTMLElement>(".Form__Status")!;
                    ackSection?.addEventListener('click', (e) => handleAcknowledgementClick(e));
                    listeners.push([ackSection, 'click', (e) => handleAcknowledgementClick(e)]);
                });
            }
        }
    }
}

export const initialiseFormRecaptcha = (form: HTMLElement, modalId: string) => {
    const recaptchaElement = form.querySelectorAll<HTMLElement>('.FormRecaptcha');
    if (recaptchaElement && recaptchaElement.length > 0) {
        const siteKey = recaptchaElement[0].dataset.epiformsSitekey;
        if (siteKey) {
            const script = document.createElement('script');
            script.id = `script-${modalId}`;
            script.src = 'https://www.google.com/recaptcha/api.js?render=' + siteKey;
            document.head.append(script);
        }
    }
};

export const destroyFormRecaptcha = (modal: HTMLElement) => {
    const modalId = modal.id;
    const recaptchaScriptElement = document.querySelector<HTMLElement>(`#script-${modalId}`);
    const grecaptchaBadge = document.querySelector<HTMLElement>('.grecaptcha-badge');
    recaptchaScriptElement?.remove();
    grecaptchaBadge?.remove();
};

const handleAcknowledgementClick=(event: Event)=>{
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const target = (event.target as HTMLElement)?.closest(".Form__Status__Message button.acknowledgement");
    if(target)
    {
        window.location.reload();
    }
}

const getCookie = (cookieName: string) => {
    const name = cookieName + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let c of ca) {
        while (c.startsWith(' ')) {
            c = c.slice(1);
        }

        if (c.startsWith(name)) {
            return c.substring(name.length, c.length);
        }
    }

    return '';
};

export function unMountOptimizelyFormExtensions(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}

//Grab the element which is controlling the data load on dependent element
const getRootControllinglement = (currentForm: HTMLElement, currentElementId: string) => {
    return currentForm.querySelector<HTMLElement>(`[data-element-id='${currentElementId}']`);
};

//Get default override url if default is  selected
const getDefaultUrl = (currentForm: HTMLElement, currentElementIds: string[], overrideUrl: string) => {
    let currentOverrideUrl= overrideUrl+"?";
    let urlParameters: Record<string,any>={};

    for(const currentElementId of currentElementIds){
        const dependentElement = getRootControllinglement(currentForm, currentElementId);
        if(!urlParameters.BU)
        {
            urlParameters.BU= dependentElement?.getAttribute('data-bu') ?? '';
        }

        urlParameters= updateOverrideUrlForElement(dependentElement,urlParameters);
    }

    for(const key in urlParameters)
    {
        currentOverrideUrl=`${currentOverrideUrl}&${key}=${urlParameters[key]}`;
    }

    return currentOverrideUrl;
};

//Update the override url on each button click with the button value
const updateOverrideUrlForElement = (element: HTMLElement | null, defaultUrlParameters: any) => {
    const elementType = element?.getAttribute('data-element-type');
    const elementValue = element?.getAttribute('data-option-text');
    if(elementType){
        defaultUrlParameters[elementType]=elementValue??'';
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return defaultUrlParameters;
};

const bindTheClickListenerToControllingElement = (
    currentForm: HTMLElement,
    currentElementIds: string[],
    dependentElement: HTMLElement,
    overrideUrl: string
) => {
    let overloadUrlParameters: Record<string,any>={};
    for (const currentElementId of currentElementIds){
        const controllingElement = getRootControllinglement(currentForm, currentElementId);
        //Get Business unit
       

        const currentControllingElement = controllingElement?.parentNode as HTMLElement;
        if(currentControllingElement){
            currentControllingElement?.addEventListener('click', (event:any) =>{ 
                let currentOverrideUrl= overrideUrl+"?";
                let eventTarget= event.target as HTMLElement;
                if(eventTarget.tagName==="SPAN"){
                    eventTarget=eventTarget.parentNode as HTMLElement;
                }
            
                if(eventTarget.tagName==="BUTTON"){
                    
                    overloadUrlParameters={};
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    overloadUrlParameters = updateOverrideUrlForElement(eventTarget, overloadUrlParameters );
                }

                if(eventTarget.tagName==="LI"){
                    overloadUrlParameters = updateOverrideUrlForElement(eventTarget, overloadUrlParameters );
                }

                const currentBu = controllingElement?.getAttribute('data-bu') ?? '';
                if(currentBu){
                    overloadUrlParameters.businessunit=currentBu;
                }

                for(const key in overloadUrlParameters)
                {
                    currentOverrideUrl=`${currentOverrideUrl}&${key}=${overloadUrlParameters[key]}`;
                }

                refreshTheDependentData(dependentElement, currentOverrideUrl)
            });
            // listeners.push([currentControllingElement, 'click', (event:any) => refreshTheDependentData(event.target as HTMLElement,dependentElement, `${overrideUrl}?businessunit='${currentBu}'`)]);
        }
    }
}

const refreshTheDependentData = (currentElement: HTMLElement, dataOverloadUrl: string) => {
    refreshSelectData(currentElement, dataOverloadUrl);
};

const initialiseEpiServerForms = () => {
    const source = '/Util/EPiServer.Forms/EPiServerForms.min.js';
    if (!isScriptAlreadyIncluded(source)) {
        const script = document.createElement('script');
        script.src = source;
        document.head.append(script);
    }
};

export const resetForm = (form: HTMLElement) => {
    // Remove success message
    const statusMessage = form.querySelector<HTMLElement>('.Form__Status__Message');
    if (statusMessage) {
        while (statusMessage.firstChild) {
            statusMessage.firstChild.remove();
        }
    }

    // Unhide main body and input elements
    const mainBody = form.querySelector<HTMLElement>('.Form__MainBody');
    if (mainBody && mainBody.style.display === 'none') {
        mainBody.style.display = 'block';
    }

    // Reset steps
    const allSteps= mainBody?.querySelectorAll(".FormStep")
    if(allSteps && allSteps.length>1){
        allSteps[0].classList.remove("hide");
        allSteps[1].classList.add("hide");
        const nextBtn = mainBody?.querySelector<HTMLButtonElement>('.Form__NavigationBar__Action.btnNext');
        if(nextBtn){
            nextBtn.removeAttribute("disabled");
        }
        const stepIndexInput = form?.querySelector<HTMLInputElement>('[name="__FormCurrentStepIndex"]');
        if(stepIndexInput){
            stepIndexInput.value="0";
        }
    }

    //hide the loading class
    $$epiforms(".EPiServerForms [data-f-type='submitbutton'] .loading").addClass("hide");
};

export const resetFormInputElements = (form: HTMLElement) => {
    // Reset value of all standard input elements
    const inputs = form.querySelectorAll<HTMLInputElement>('.Form__MainBody .FormTextbox__Input,.Form__MainBody .Form__CustomInput');
    for (const input of inputs) {
        input.value = '';
    }

    // Reset value of all checkboxes
    const checkboxes = form.querySelectorAll<HTMLInputElement>('.Form__MainBody .FormChoice__Input--Checkbox,.Form__MainBody .FormChoice__Input--Radio');
    for (const checkbox of checkboxes) {
        checkbox.checked = false;
    }

    resetSelectField(form);
};

export const resetValidations = (form: HTMLElement) => {
    const validationFailedElements = form.querySelectorAll<HTMLElement>('.ValidationFail');
    const validationFailedErrors = form?.querySelectorAll<HTMLElement>('.Form__Element__ValidationError');

    for (const validationFailedError of validationFailedErrors) {
        // Hides validation error message
        validationFailedError.classList?.add('hidden');
        validationFailedError.textContent = '';
    }

    for (const validationFailedElement of validationFailedElements) {
        validationFailedElement.classList.remove('ValidationFail');
    }
};

const isScriptAlreadyIncluded = (source: string) => {
    const scripts = document.querySelectorAll<HTMLElement>('script');
    for (const script of scripts) {
        const scriptSource = script.getAttribute('src');
        if (scriptSource === source) return true;
    }

    return false;
};


// Archived function
// Used with modal submit button and confirmation modal
// const initialiseModalSubmitButton = (
// 	listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
// 	form: HTMLElement,
// 	confirmationModal: HTMLElement,
// 	modalSubmitButton: HTMLElement
// ) => {
// 	const formType = modalSubmitButton.dataset.formType;

// 	if (formType === 'RemindMe') {
// 		//With "Allow multiple submissions from the same IP/cookie" turned on on the form,
// 		//using localstorage to determine if user submitted the form for the partuclar event and disable the button accordingly.
// 		//We cannot use the "Allow multiple submissions from the same IP/cookie" unticked
// 		// because this will restrict from submitting the form on all events

// 		let disableButton = false;
// 		const currentEventPageId = form.querySelector<HTMLInputElement>('input[name="__FormHostedPage"]');
// 		if (currentEventPageId) {
// 			const eventId = currentEventPageId.value;
// 			const localStorageEventId = localStorage.getItem('event-id');
// 			if (localStorageEventId) {
// 				const parsedEventId = JSON.parse(localStorageEventId);
// 				for (const index in parsedEventId) {
// 					if (parsedEventId[index].split('|')[0] == eventId) {
// 						disableButton = true;
// 					}
// 				}
// 			}
// 		}

// 		const submitButton = form.querySelector<HTMLButtonElement>('button[type="submit"]');
// 		if (submitButton) {
// 			submitButton.disabled = disableButton;
// 		}

// 		// CMS setting can load form with button disabled, update text accordingly
// 		updateFormSubmitText(form);
// 	}

// 	if (typeof $$epiforms !== 'undefined') {
// 		// We are using jQuery here as that is Optimizely Forms is implemented and we are piggy backing on that logic
// 		$$epiforms(document).ready(function myfunction() {
// 			$$epiforms('.EPiServerForms').on('formsSubmitted', () => {
// 				const formBody = form.querySelector<HTMLElement>('.Form__MainBody');
// 				const formStatus = form.querySelector<HTMLElement>('.Form__Status');

// 				// Hide the Form Status element on the confirmation page
// 				if (formStatus) {
// 					formStatus.classList.add('!hidden');
// 				}

// 				// Keep the Form Body element visable
// 				if (formBody) {
// 					formBody.classList.add('!block');
// 				}

// 				if (formType === 'RemindMe') {
// 					// When the modal is closed update the form's submit button to be disabled and change text to "Attending"
// 					const modalButtons = confirmationModal.querySelectorAll<HTMLButtonElement>('button');

// 					for (const modalButton of modalButtons) {
// 						modalButton.addEventListener('click', () => disableFormSubmitButton(form, formType));
// 						listeners.push([modalButton, 'click', () => disableFormSubmitButton(form, formType)]);
// 					}

// 					// Get the ics event data from the submit button with modal form element
// 					if (modalSubmitButton.dataset.formCalender) {
// 						// Update the event text anchor to download the ics event
// 						const modalAnchors = confirmationModal.querySelectorAll<HTMLAnchorElement>('a');

// 						for (const anchor of modalAnchors) {
// 							if (anchor.innerHTML === 'event') {
// 								anchor.href = generateIcsUrl(modalSubmitButton.dataset.formCalender);
// 							}
// 						}
// 					}
// 				}

// 				// Display Bootstrap modal
// 				const bsConfirmationModal = new Modal(confirmationModal);
// 				bsConfirmationModal.show();
// 			});

// 			$$epiforms('.EPiServerForms').on('formsStepValidating', (event: any) => {
// 				// Hide Bootstrap modal if form is not valid
// 				if (!event.isValid && confirmationModal) {
// 					const bsConfirmationModal = new Modal(confirmationModal);
// 					bsConfirmationModal.hide();
// 				}
// 			});
// 		});
// 	}
// };

// const disableFormSubmitButton = (form: HTMLElement, formType: string) => {
// 	// Since we don't hide the form on submit (as per Opti default behaviour)
// 	// disable the submit button to prevent duplicate entries if data-form-disable-button-onclick exists
// 	if (formType === 'RemindMe') {
// 		const eventPageId = form.querySelector('input[name="__FormHostedPage"]') as HTMLInputElement;
// 		var eventPageIdArray = [];
// 		var userIdentityId = '';
// 		if (eventPageId) {
// 			if (localStorage.getItem('event-id')) {
// 				eventPageIdArray = JSON.parse(localStorage.getItem('event-id')!);
// 			}
// 			userIdentityId = localStorage.getItem('website-user-identity')!;
// 			if (userIdentityId != '') {
// 				var currentEventUserId = eventPageId.value + '|' + userIdentityId;
// 				if (!eventPageIdArray.includes(currentEventUserId)) {
// 					eventPageIdArray.push(currentEventUserId);
// 					localStorage.setItem('event-id', JSON.stringify(eventPageIdArray));
// 				}
// 			}
// 		}
// 		const submitButton = form.querySelector<HTMLButtonElement>('button[type="submit"]');
// 		if (submitButton) {
// 			submitButton.disabled = submitButton.dataset.formDisableButtonOnclick?.toLowerCase() == 'true' ?? false;
// 		}
// 		updateFormSubmitText(form, true);
// 	}
// };
// const updateFormSubmitText = (form: HTMLElement, forceUpdate = false) => {
// 	// On submit, if the property data-form-alternate-text-on-click exists set the button text to that
// 	// We only want to update buttons that have been disabled (either after form submission, or page load in certain circumstances)
// 	const submitButton = form.querySelector<HTMLButtonElement>('button[type="submit"]');

// 	if (submitButton && (submitButton.disabled || forceUpdate)) {
// 		const alternateText = submitButton.dataset.formAlternateTextOnClick ?? '';
// 		if (alternateText.length > 0) submitButton.textContent = alternateText;

// 		// TODO: Should this be moved outside?
// 		const formStatusBlock = form.querySelector<HTMLButtonElement>('.Form__Status');
// 		formStatusBlock?.classList.add('hidden');
// 	}
// };
